export default __webpack_public_path__ + "static/media/bottom-banner.600d01b7.jpg";